import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const Profile = withSafeSuspense(lazy(
  async () => ({ default: (await import('./profile')).Profile })
))
